import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setChecklistCardTypeDefault, setChecklistCardTypeCategoryDefault, setChecklistSeriesDefault } from '../../../../../../store/system/system.action';

// styles
import {
    CardDisplayContainer,
    LeftCardContent,
    CardNumber,
    CardDetails,
    CardHeader,
    AttributesContainer,
    AddBtn
} from './CardDisplay.styles';

// components
import CardAttribute from '../../../../../../components/card-attribute/CardAttribute';

export default function CardDisplay({ wasRemoved, card, path = null }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleNavigateToCard = () => {
        // Extract URL parameters from the path to update system defaults
        if (path) {
            const pathParts = path.split('/');
            // Path format: /checklists/sport/year/manufacturer/series/cardType/cardTypeCategory
            if (pathParts.length >= 8) {
                const series = pathParts[5];
                const cardType = pathParts[6];
                const cardTypeCategory = pathParts[7];
                // Update system defaults to match the target checklist
                dispatch(setChecklistSeriesDefault(series));
                dispatch(setChecklistCardTypeDefault(cardType));
                dispatch(setChecklistCardTypeCategoryDefault(cardTypeCategory));
            }
        }
        
        navigate(path);
    }

    return (
        <CardDisplayContainer>
            <LeftCardContent>
                <CardNumber>
                    <h4>{card.cardNumber}</h4>
                </CardNumber>
                <CardDetails>
                    <CardHeader>
                        {card.name.map((name, index) => (
                            <span key={index}>
                                <h3 style={{ display: 'inline' }}>{name}</h3>
                                {index < card.name.length - 1 && ' • '}
                            </span>
                        ))}
                    </CardHeader>
                    <AttributesContainer>
                        {card.cardAttributes && card.cardAttributes.length !== 0 &&
                            <div className='card-attributes-container'>
                                {card.cardAttributes.map(attribute => (
                                    <CardAttribute key={attribute} text={attribute} />
                                ))}
                            </div>
                        }
                        {card.cardAttributes && card.cardAttributes.length !== 0 && card.collectedCards && card.collectedCards.length !== 0 &&
                            <h4>•</h4>
                        }
                        {card.collectedCards &&
                            <div className='card-attributes-container'>
                                {card.collectedCards.map(parallel => {
                                    // Check if both cardPrintNumber and cardSupply exist and have values
                                    const hasPrintInfo = parallel.cardPrintNumber != null && parallel.cardSupply != null;
                                    const printInfo = hasPrintInfo ? `(${parallel.cardPrintNumber}/${parallel.cardSupply})` : '';
                                    const qty = parallel.cardQty != null && !Number.isNaN(Number(parallel.cardQty))
                                        ? parallel.cardQty
                                        : 0;
                                    return (
                                        <CardAttribute
                                            key={parallel.cardParallelName}
                                            color={parallel.cardColor}
                                            text={`${parallel.cardParallelName}${printInfo ? ` ${printInfo}` : ''} (QTY: ${qty})`} />
                                    );
                                })}
                            </div>
                        }
                    </AttributesContainer>
                </CardDetails>
            </LeftCardContent>
            <AddBtn $isActive={true} onClick={handleNavigateToCard}>
                <h4>VIEW IN CHECKLIST</h4>
            </AddBtn>
        </CardDisplayContainer>
    )
}
